export function isVertical(offerLayout) {
    return offerLayout.toLowerCase().includes('column');
}

export function isMini(offerLayout) {
    return offerLayout.toLowerCase().includes('mini');
}
